













































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { SlotItem } from "@/models/slotItem";
import { stringUtil } from "@/models/stringUtil.ts";
import { Vector2 } from "@babylonjs/core";
import { placementManager } from "@/models/placementManager.ts";
import { ElementType, SpecyficType } from "@/models/element.ts";
import { slotsManager } from "@/models/slotsManager.ts";
import * as BABYLON from "@babylonjs/core";
import { Scene, Engine } from "@babylonjs/core";
import Loading from "@/components/loading/Loading.vue";
import { SceneConfiguration } from "@/models/sceneConfiguration.ts";
import { messager } from "@/models/messager";
import { ElementMenuItem } from "@/models/elementMenuItem.ts";
import { FurnitureManager } from "@/models/furnitureManager.ts";
import { hintsManager } from "@/models/message/hintsManager.ts";

@Component({
  components: {
    Loading
  }
})
export default class SlotsPreview extends Vue {
  @Prop({ type: Scene, default: null }) scene!: Scene;
  @Prop({ type: Engine, default: null }) engine!: Engine;
  @Prop({ type: Object, default: null })
  sceneConfiguration!: SceneConfiguration;

  private stringUtil = stringUtil;
  private availableSlots: SlotItem[] = [];
  private previousSelectedElement: ElementMenuItem | null = null;
  private furnitureManager: FurnitureManager = new FurnitureManager();

  get isLoading() {
    return this.currentImage == null;
  }

  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "selectElementMenuItem") {
        this.preparePanel();
      }
    });
  }

  preparePanel() {
    if (this.scene != null && this.engine != null) {
      this.currentImage = null;
      this.prepareSceneScreen(this.engine, this.scene);
    } else {
      this.prepareScreenSceneCallback("");
    }
  }

  private click(slot: SlotItem) {
    this.$store.commit("selectSlotItem", slot);
  }

  currentImage: string | null = null;

  private prepareSceneScreen(engine: BABYLON.Engine, scene: BABYLON.Scene) {
    const camera = scene.cameras[0];
    if (camera) {
      const currentPosition = camera.position.clone();
      this.sceneConfiguration.centerCamera();
      BABYLON.Tools.CreateScreenshotUsingRenderTarget(
        engine,
        camera,
        400,
        data => {
          camera.position = currentPosition;
          this.prepareScreenSceneCallback(data);
        }
      );
    } else {
      this.prepareScreenSceneCallback("");
    }
  }

  private getImage(state: string) {
    return state ? state : "";
  }

  private prepareScreenSceneCallback(img: string) {
    // console.log(img);
    this.currentImage = img != null ? img : "";

    const element: ElementMenuItem = this.$store.getters.scene
      .selectedElementMenuItem;
    this.availableSlots = slotsManager.createSlots(element);
    if (!this.availableSlots.length) {
      if (this.previousSelectedElement !== element) {
        hintsManager.showHint();
      }
      this.$store.commit("clearSceneState");
      this.previousSelectedElement = null;
      return;
    }
    this.previousSelectedElement = element;
  }
}
